import {Injectable} from "@angular/core";
import {ILibrarySelection} from "../../library/library.objects";
import {CompletionState} from "../usermodel/usermodel.objects";
import {BookSessionType, ContentProgression} from "../../constants";
import {StudentConfiguration} from "../assignment/student.configuration";
import {UtilitiesService} from "../utilities.service";
import {userError} from "@angular/compiler-cli/src/transformers/util";

@Injectable()
export class LibraryService {

    constructor(private studentConfiguration:StudentConfiguration) {}

    determineCurrentSelection(selections: ILibrarySelection[],
                              unfinishedSelections: ILibrarySelection[]): ILibrarySelection {

        let currentSelection: ILibrarySelection = null;

        for (let i = 0; i < selections.length; i++) {
            let selection: ILibrarySelection = selections[i];

            if (selection.isCurrent) {
                currentSelection = selection;
                break;
            }
        }

        // for a locked progression when there is no current selection so just pick the first unfinished one
        if (this.isLibraryLocked() && !currentSelection && unfinishedSelections.length > 0) {
            currentSelection = unfinishedSelections[0];
        }

        // so this can be null for unlocked progression and when there are no more unfinished selections
        return currentSelection;
    }

    determineNextSelection(currentSelection: ILibrarySelection,
                           unfinishedSelections: ILibrarySelection[]): ILibrarySelection {

        let nextSelection: ILibrarySelection;

        if (this.isLibraryLocked()) {
            nextSelection = unfinishedSelections.filter(item => item !== currentSelection).shift();
        }

        // this can be null for unlocked progression and when there are not remaining unfinished selections
        return nextSelection;
    }

    getGradeEquivForFormat(clickedSelection: ILibrarySelection, selections: ILibrarySelection[], currentSelection: ILibrarySelection) {
        if (!!clickedSelection.storyDescription.seriesName) {
            // if there is a 'Current Selection' showing at the top, that will not be included in the selections list,
            // so add it for a complete list
            const allSelections = !!currentSelection ? selections.concat(currentSelection) : selections;
            const seriesSelections = allSelections.filter((selection) =>
                clickedSelection.storyDescription.seriesName === selection.storyDescription.seriesName);
            if (seriesSelections.length > 0) {
                const seriesAverageGradeEquiv = seriesSelections.reduce((sum, current) =>
                    sum += UtilitiesService.determineATOSLevel(current.storyDescription), 0) / seriesSelections.length;
                if (!isNaN(seriesAverageGradeEquiv) && seriesAverageGradeEquiv > 0) {
                    return seriesAverageGradeEquiv;
                }
            }
        }
        return UtilitiesService.determineATOSLevel(clickedSelection.storyDescription);
    }

    isLibraryLocked():boolean {
        return this.studentConfiguration.getContentProgression() === ContentProgression.LOCKED;
    }
}
